import clsx from "clsx";
import type React from "react";
import { useState } from "react";

import type { GameWord } from "~/components/Game";
import { GameClue } from "~/components/Game/GameClue";
import { useGame } from "~/components/GameContext";
import { GameLabel } from "~/components/GameLabel";
import { useLocale } from "~/hooks/locale";

import { CardSide } from "./CardSide";

export const LastWord: React.FC<{ word: GameWord }> = ({ word }) => {
  const { t } = useLocale();
  const { game } = useGame();

  const [isFlipped, setIsFlipped] = useState(game.mode === "imcq");

  return (
    <div
      role="button"
      className="relative aspect-video p-4 perspective-1000 max-lg:sm:aspect-tv md:p-6"
      onClick={() => {
        setIsFlipped((prev) => !prev);
      }}
    >
      <GameLabel>{t("reveal_last_word")}</GameLabel>
      <div
        className={clsx(
          "absolute inset-0 select-none rounded border bg-base-100 shadow-sm transition-transform duration-300 transform-style-3d",
          isFlipped && "rotate-y-180",
        )}
      >
        <CardSide>
          <GameClue autoPlay={false} word={word} />
        </CardSide>
        <CardSide isBackSide>
          <div className="p-4 text-2xl font-medium md:p-6 md:text-3xl">
            {word.solution}
          </div>
        </CardSide>
      </div>
    </div>
  );
};
